import Navigation from '@App/navigation'
import { SUGGESTION_STATUS, SUGGESTION_STATUS_VALUES } from '@Components/MatchComponents/v2/suggestion-status'
import StatusComponent from '@Components/Status'
import { Link } from 'react-router'
import React from 'react'
import { SEARCH_PARAM } from '@App/navigation/param'

interface LinkedStatusComponentProps {
    status: SUGGESTION_STATUS
    count?: number
    rhId: number
}

const LinkedStatusComponent = ({ count, rhId, status }: LinkedStatusComponentProps) => (
    <Link
        to={{
            pathname: Navigation.rightholder.matchClaim.matchHistory(rhId),
            search: `?${SEARCH_PARAM.matchHistoryFilter}=${status}`,
        }}
    >
        <StatusComponent withCount status={SUGGESTION_STATUS_VALUES[status]} big={false} count={count} circleFirst />
    </Link>
)

export default LinkedStatusComponent
